import { Form,Alert } from "antd";
import CustomInput from "../CustomInput/Input";
import FormFooter from "./FormFooter";
import { feedbackRules } from "../../helpers/helpers";
import { useEffect } from "react";
import { resetInterestState } from "../../redux/slices/DealSlice";
import { useDispatch } from "react-redux";

const ReasonForm = ({
    label,
    placeholder,
    btnName,
    submitLoading,
    submitError,
    onClose,
    handleOnFormSubmit,
}) => {
    const [form] = Form.useForm();
    const dispatch = useDispatch();

    useEffect(() => {
            return () => {
                dispatch(resetInterestState())
            }
        }, [dispatch]);

    return (
        <Form layout="vertical" form={form} onFinish={handleOnFormSubmit}>
            <CustomInput
                rows={4}
                name="reason"
                label={label}
                placeholder={placeholder}
                isRequired={true}
                isTextArea={true}
                rules={feedbackRules}
            />

            {submitError && <Alert message={submitError} type="error" showIcon />}

            <FormFooter
                onCancelClick={() => {
                    onClose();
                    form.resetFields();
                }}
                submitLoading={submitLoading}
                btnName={btnName}
            />
        </Form>
    );
};

export default ReasonForm;
